import { cn } from '@/lib/utils';

import { AdditionalSVGProps } from '@/models/Svg';

export const LinkedinIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#010f1d', ...rest } = props;

  return (
    <>
      <svg
        width='30'
        height='30'
        viewBox='0 0 30 30'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={cn(`fill-[${fill}]`, className)}
        {...rest}
      >
        <path d='M26 0C26.862 0 27.6886 0.34241 28.2981 0.951903C28.9076 1.5614 29.25 2.38805 29.25 3.25V26C29.25 26.862 28.9076 27.6886 28.2981 28.2981C27.6886 28.9076 26.862 29.25 26 29.25H3.25C2.38805 29.25 1.5614 28.9076 0.951903 28.2981C0.34241 27.6886 0 26.862 0 26V3.25C0 2.38805 0.34241 1.5614 0.951903 0.951903C1.5614 0.34241 2.38805 0 3.25 0H26ZM25.1875 25.1875V16.575C25.1875 15.17 24.6294 13.8226 23.6359 12.8291C22.6424 11.8356 21.295 11.2775 19.89 11.2775C18.5087 11.2775 16.9 12.1225 16.12 13.39V11.5863H11.5863V25.1875H16.12V17.1763C16.12 15.925 17.1275 14.9012 18.3787 14.9012C18.9821 14.9012 19.5608 15.1409 19.9874 15.5676C20.4141 15.9942 20.6537 16.5729 20.6537 17.1763V25.1875H25.1875ZM6.305 9.035C7.02904 9.035 7.72343 8.74738 8.2354 8.2354C8.74738 7.72343 9.035 7.02904 9.035 6.305C9.035 4.79375 7.81625 3.55875 6.305 3.55875C5.57665 3.55875 4.87813 3.84809 4.36311 4.36311C3.84809 4.87813 3.55875 5.57665 3.55875 6.305C3.55875 7.81625 4.79375 9.035 6.305 9.035ZM8.56375 25.1875V11.5863H4.0625V25.1875H8.56375Z' />
      </svg>
    </>
  );
};
